import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { LoadCurrentAccount } from '@/javascript/domain/usecases'
import { Account } from '@/javascript/domain/entities/account'

const useRoutingConfig = (loadAccount: LoadCurrentAccount) => {
  const [accountInfo, setAccountInfo] = useState<Account>(null)
  const [date, setDate] = useState(dayjs())
  const [workingHours, setWorkingHours] = useState({
    startTime: dayjs(),
    startTimeError: '',
    endTime: dayjs().add(1, 'hour'),
    endTimeError: '',
  })

  useEffect(() => {
    loadAccount.load().then(data => {
      if (data) setAccountInfo(data)
    })
  }, [])

  return { accountInfo, date, setDate, workingHours, setWorkingHours }
}

export default useRoutingConfig
